import PageBanner from '../../../components/shared/PageBanner';
import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { Button, Select, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import CompanyService from '../../../services/Admin/Company';
import UserList from './UserList';

const UserManagementPage: FunctionComponent = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [companies, setCompanies] = useState<Array<any>>([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState<string>('');

    useEffect(() => {
        const fetchCompanies = async () => {
            setIsLoading(true);
            try {
                const response = await CompanyService.fetchCompanies(0, 200);
                const companyItems = response?.items || [];
                setCompanies(companyItems);
                if (companyItems.length > 0) {
                    setSelectedCompanyId(String(companyItems[0].id));
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchCompanies();
    }, []);

    const companyOptions = useMemo(
        () =>
            companies.map((company) => ({
                value: String(company.id),
                label: `${company.name} (${company.id})`,
            })),
        [companies],
    );

    return (
        <div className="documents-page documents-page--with-app-header">
            <div className="documents-page__inner">
                <PageBanner title="User Management" storageKey="banner-user-management">
                    <div className="documents-page__subtitle">Create users and assign roles by company.</div>
                </PageBanner>

                <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', padding: 16, display: 'grid', gap: 12, maxWidth: 900 }}>
                    <label htmlFor="company-select" style={{ fontWeight: 500 }}>Company</label>
                    <Select
                        id="company-select"
                        showSearch
                        optionFilterProp="label"
                        value={selectedCompanyId || undefined}
                        onChange={setSelectedCompanyId}
                        options={companyOptions}
                        placeholder="Select company"
                    />
                </div>

                <div style={{ marginTop: 16 }}>
                    {isLoading ? (
                        <Spin tip="Loading companies..." />
                    ) : selectedCompanyId ? (
                        <UserList key={selectedCompanyId} companyId={selectedCompanyId} />
                    ) : (
                        <div style={{ display: 'grid', gap: 10, color: '#6b7280' }}>
                            <div>No companies available. Create a company first, then add users to it.</div>
                            <Button type="primary" style={{ width: 'fit-content' }} onClick={() => history.push('/admin-panel/company')}>
                                Go to Company Management
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserManagementPage;
